export default {
  en: {
    updating: 'Publishing {entity} integration',
    updated: '{entity} integration was published',
    widget: {
      title: 'Integration of Widget',
      description: 'Integrate Videsk on your web with a widget.',
      tabs: {
        colors: 'Colors and Texts',
        forms: 'Forms',
        integration: 'Integration',
      },
      integration: {
        title: 'The final step!',
        unavailable: 'Unavailable',
        soon: 'Soon',
        description: 'To integrate Videsk into your website you can copy and paste this line inside the body tag:',
        alternative: 'Or you can install with the follow plugins/modules :',
        propagate: 'The changes you make will be automatically propagated on your website.',
        plugins: {
          wordpress: 'Integrate Videsk in your WordPress website.',
          magento: 'Integrate Videsk in your Magento e-commerce.',
          prestashop: 'Integrate Videsk in your Prestashop e-commerce.',
          shopify: 'Integrate Videsk in your Shopify e-commerce.',
        },
        ssl: {
          invalid: 'The URL is not valid, please check and try again.',
          valid: 'The website is compatible with Videsk widget.',
          description: 'First need check if you website is compatible with Videsk. Need SSL in your website.',
          placeholder: 'Enter your website',
          words: {
            valid: 'Valid (Compatible)',
            expired: 'SSL Ok',
            expireon: 'Expire On',
            days: 'day | days',
            remaining: 'Remaining Days',
          },
          button: 'Check compatibility',
        },
      },
      colors: {
        select: 'Select a color',
        text: 'Text Color',
        gradient: 'Header Gradient',
        buttons: 'Background buttons',
        alert: 'Try use background colors that have a good contrast with text for inclusive design.',
        logo: {
          label: 'Logo URL:',
          tooltip: 'Logo size (Default: 31px)',
          placeholder: 'Enter de URL or logo',
        },
      },
      texts: {
        alert: 'It is advisable to fill in the fields to guide your clients and deliver more personalized attention.',
        head: {
          title: 'Title text',
          subtitle: 'Subtitle text',
        },
        terms: {
          label: 'URL of terms and conditions',
          tooltip: 'You can add your own website for terms and conditions. Must be compatible with iframe.',
        },
      },
      form: {
        alert: 'Select a department and create/edit a form. Click on «Forms Documentation» for more information.',
        alert2: 'To request information from your customers, you must configure a form by department, otherwise information will not be requested.',
        btnDocs: 'Forms Documentation',
        example: 'A example was loaded',
        parseError: 'The JSON scheme is incorrect, correct the format. The last change was omitted',
        last: 'Automatic backup of the last change',
      },
    },
  },
  es: {
    updating: 'Publicando Integración {entity}',
    updated: 'Integración {entity} Publicada',
    widget: {
      title: 'Integración de Widget',
      description: 'Integre Videsk en su sitio web con widget.',
      tabs: {
        colors: 'Colores y Textos',
        forms: 'Formularios',
        integration: 'Integración',
      },
      integration: {
        title: '¡Falta un solo paso!',
        unavailable: 'No disponible',
        soon: 'Pronto',
        description: 'Para integrar Videsk en tú sitio web puedes copiar y pegar esta línea dentro de la etiqueta body:',
        alternative: 'O bien puedes instalar con los siguientes plugins/módulos:',
        propagate: 'Los cambios que realices se propagarán automáticamente en tú sitio web.',
        plugins: {
          wordpress: 'Integre Videsk en su sitio WordPress.',
          magento: 'Integre Videsk en su tienda Magento.',
          prestashop: 'Integre Videsk en su tienda Prestashop.',
          shopify: 'Integre Videsk en su tienda Shopify.',
        },
        ssl: {
          invalid: 'La URL ingresada no es válida, por favor inténtalo de nuevo.',
          valid: 'El sitio web es compatible con Videsk widget.',
          description: 'Primero necesita verificar si su sitio web es compatible con Videsk. Necesita SSL en su sitio web.',
          placeholder: 'Ingresa tu sitio web',
          words: {
            valid: 'Válido (Compatible)',
            expired: 'SSL Ok',
            expireon: 'Expira el',
            days: 'día | días',
            remaining: 'Días restantes',
          },
          button: 'Verificar compatibilidad',
        },
      },
      colors: {
        select: 'Seleccione un color',
        text: 'Color texto',
        gradient: 'Gradiente cabecera',
        buttons: 'Fondo botones',
        alert: 'Intente utilizar colores de fondo que tengan un buen contraste con el texto para un diseño inclusivo.',
        logo: {
          label: 'URL logo:',
          tooltip: 'Tamaño Logo (Por defecto: 31px)',
          placeholder: 'Ingrese URL del logo',
        },
      },
      texts: {
        alert: 'Es recomendable completar los campos para guiar a sus clientes y brindarles una atención más personalizada.',
        head: {
          title: 'Texto del título',
          subtitle: 'Texto del subtítulo',
        },
        terms: {
          label: 'URL de términos y condiciones',
          tooltip: 'Puede agregar su propio sitio web para los términos y condiciones. Debe ser compatible con iframe.',
        },
      },
      form: {
        alert: 'Seleccione un departamento y cree/edite un formulario. Haga clic en «Documentación de Formularios» para más información.',
        alert2: 'Para solicitar información a sus clientes deberá configurar un formulario por departamento, en caso contrario no se solicitará información.',
        btnDocs: 'Documentación de Formularios',
        example: 'Se ha cargado una plantilla',
        parseError: 'El esquema JSON es incorrecto, corriga el formato. Se ha omitido el último cambio',
        last: 'Último cambio respaldado localmente',
      },
    },
  },
};
